import { Action } from '@ngrx/store'
import { ApiSetting } from '../../core/models/setting';

export const SET_VIEW_TYPE = '[Catalog] Set View Type'
export const SET_FULL_WIDTH_VIEW = '[App] Set Full Width View'

export const GET_TENANT_SETTINGS = '[App] Get Tenant Preferences'
export const GET_TENANT_SETTINGS_SUCCESS = '[App] Get Tenant Preferences Success'
export const GET_TENANT_SETTINGS_FAILED = '[App] Get Tenant Preferences Failed'

export class SetViewType implements Action {
    readonly type = SET_VIEW_TYPE
    constructor(public payload: string) {}
}

export class SetFullWidthView implements Action {
  readonly type = SET_FULL_WIDTH_VIEW
  constructor(public payload: boolean) {}
}

export class GetTenantPreferences implements Action {
  readonly type = GET_TENANT_SETTINGS
}

export class GetTenantPreferencesSuccess implements Action {
  readonly type = GET_TENANT_SETTINGS_SUCCESS
  constructor(public payload: ApiSetting[]) {}
}

export class GetTenantPreferencesFailed implements Action {
  readonly type = GET_TENANT_SETTINGS_FAILED
  constructor(public payload: string) {}
}


export type Actions = 
    SetViewType
    | SetFullWidthView
    | GetTenantPreferences
    | GetTenantPreferencesSuccess
    | GetTenantPreferencesFailed
